.tooltipWrapper {
  max-width: fit-content;
}

.tooltipColumnTitle {
  align-self: center;
}

.text {
  max-width: 150px;
}

.white {
  color: var(--paletteWhite0);
}

.smallPadding {
  padding: var(--spacingMd);
}
